import { isMacOs } from '@jira/platform__os-detection/src/isMacOs.tsx';

export const isCommandPaletteTrigger = (ev: KeyboardEvent): boolean => {
	if (ev.key !== 'k') return false;
	if (isMacOs()) {
		if (!ev.metaKey) return false;
	} else if (!ev.ctrlKey) return false;
	return true;
};
